exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-items{\r\n    margin:10px 10px;\r\n}\r\nul{\r\n    margin-bottom: 0;\r\n}\r\n.timelineBody{\r\n    margin-bottom: 0;\r\n}\r\n.form-group{\r\n    margin-bottom: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/list-item/list-item.component.css
// module id = ../../../../../src/app/list-item/list-item.component.css
// module chunks = main